import { React, useState, useEffect, useRef, useContext } from "react";
import Button from "@mui/material/Button";
import axios from "axios";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid } from '@mui/x-data-grid';
import PCSelectModal from "../PCSelectModal";

function QualitySelectModal({ title, onClose, openType, handleQualityClick }) {
  const appStore = useContext(AppContext);
  const searchRef = useRef(null);
  const [keyword, setKeyword] = useState('');
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [originRows, setOriginRows] = useState([]);
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    id: false,
    quality_name: true,
    quality_measurement_standard: false,
    quality_measurement_standard_name: true,
    quality_item_id: false,
    quality_item_name: true,
    quality_item_spec: true,
    quality_item_width: false,
    quality_item_depth: false,
    quality_item_height: false,
    quality_pass_start_number: false,
    quality_pass_start_standard: false,
    quality_pass_end_number: false,
    quality_pass_end_standard: false,
    quality_option1_name: false,
    quality_option1_pass_yn: false,
    quality_option2_name: false,
    quality_option2_pass_yn: false,
    quality_option3_name: false,
    quality_option3_pass_yn: false,
    quality_option4_name: false,
    quality_option4_pass_yn: false,
    quality_option5_name: false,
    quality_option5_pass_yn: false,
    quality_option6_name: false,
    quality_option6_pass_yn: false,
    quality_option_name: false,
    quality_option_pass_yn: false
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    searchRef.current.focus();
    handleView();

    setColumnVisibilityModel({
      id: false,
      quality_name: true,
      quality_measurement_standard: false,
      quality_measurement_standard_name: true,
      quality_item_id: false,
      quality_item_name: true,
      quality_item_spec: true,
      quality_item_width: false,
      quality_item_depth: false,
      quality_item_height: false,
      quality_pass_start_number: false,
      quality_pass_start_standard: false,
      quality_pass_end_number: false,
      quality_pass_end_standard: false,
      quality_option1_name: false,
      quality_option1_pass_yn: false,
      quality_option2_name: false,
      quality_option2_pass_yn: false,
      quality_option3_name: false,
      quality_option3_pass_yn: false,
      quality_option4_name: false,
      quality_option4_pass_yn: false,
      quality_option5_name: false,
      quality_option5_pass_yn: false,
      quality_option6_name: false,
      quality_option6_pass_yn: false,
      quality_option_name: false,
      quality_option_pass_yn: false
    });
  }, []);


  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  const onSubmitSearch = (e) => {
    //입력 검색어는 Enter로 조회.
    if (e.key === "Enter") {
      handleView();
    }
  };
  
  const handleSetting = () => {
    setColumns([
        { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
        { field: 'quality_name', headerName: '품질명', width: 180, headerAlign: 'center', align:'left' },
        { field: 'quality_measurement_standard', headerName: 'quality_measurement_standard', width: 0, headerAlign: 'center'},
        { field: 'quality_measurement_standard_name', headerName: '품질측정기준', width: 100, headerAlign: 'center', align:'center' },
        { field: 'quality_item_id', headerName: 'quality_item_id', width: 0, headerAlign: 'center'},
        { field: 'quality_item_name', headerName: '품목명', width: 110, headerAlign: 'center', align:'left' },
        { field: 'quality_item_spec', headerName: '규격', width: 180, headerAlign: 'center', align:'left' },
        { field: 'quality_item_width', headerName: 'quality_item_width', width: 0, headerAlign: 'center'},
        { field: 'quality_item_depth', headerName: 'quality_item_depth', width: 0, headerAlign: 'center'},
        { field: 'quality_item_height', headerName: 'quality_item_height', width: 0, headerAlign: 'center'},
        { field: 'quality_pass_start_number', headerName: 'quality_pass_start_number', width: 0, headerAlign: 'center'},
        { field: 'quality_pass_start_standard', headerName: 'quality_pass_start_standard', width: 0, headerAlign: 'center'},
        { field: 'quality_pass_end_number', headerName: 'quality_pass_end_number', width: 0, headerAlign: 'center'},
        { field: 'quality_pass_end_standard', headerName: 'quality_pass_end_standard', width: 0, headerAlign: 'center'},
        { field: 'quality_option1_name', headerName: 'quality_option1_name', width: 0, headerAlign: 'center'},
        { field: 'quality_option1_pass_yn', headerName: 'quality_option1_pass_yn', width: 0, headerAlign: 'center'},
        { field: 'quality_option2_name', headerName: 'quality_option2_name', width: 0, headerAlign: 'center'},
        { field: 'quality_option2_pass_yn', headerName: 'quality_option2_pass_yn', width: 0, headerAlign: 'center'},
        { field: 'quality_option3_name', headerName: 'quality_option3_name', width: 0, headerAlign: 'center'},
        { field: 'quality_option3_pass_yn', headerName: 'quality_option3_pass_yn', width: 0, headerAlign: 'center'},
        { field: 'quality_option4_name', headerName: 'quality_option4_name', width: 0, headerAlign: 'center'},
        { field: 'quality_option4_pass_yn', headerName: 'quality_option4_pass_yn', width: 0, headerAlign: 'center'},
        { field: 'quality_option5_name', headerName: 'quality_option5_name', width: 0, headerAlign: 'center'},
        { field: 'quality_option5_pass_yn', headerName: 'quality_option5_pass_yn', width: 0, headerAlign: 'center'},
        { field: 'quality_option6_name', headerName: 'quality_option6_name', width: 0, headerAlign: 'center'},
        { field: 'quality_option6_pass_yn', headerName: 'quality_option6_pass_yn', width: 0, headerAlign: 'center'},
        { field: 'quality_option_name', headerName: 'quality_option_name', width: 0, headerAlign: 'center'},
        { field: 'quality_option_pass_yn', headerName: 'quality_option_pass_yn', width: 0, headerAlign: 'center'}
    ]);
  }

  const handleView = () => {
    axios.get('/api/SelectCommon/QualityList',
        {
        params : {
          search: keyword
        }
      },
      { withCredentials: true }
    )
    .then((response) => {
        var array = response.data.map((item, index) => ({
            id: item.quality_id,
            quality_name: item.quality_name,
            quality_measurement_standard: item.quality_measurement_standard,
            quality_measurement_standard_name: item.quality_measurement_standard_name,
            quality_item_id: item.quality_item_id,
            quality_item_name: item.quality_item_name,
            quality_item_spec: item.quality_item_spec,
            quality_item_width: item.quality_item_width,
            quality_item_height: item.quality_item_height,
            quality_item_depth: item.quality_item_depth,
            quality_pass_start_number: item.quality_pass_start_number,
            quality_pass_start_standard: item.quality_pass_start_standard,
            quality_pass_end_number: item.quality_pass_end_number,
            quality_pass_end_standard: item.quality_pass_end_standard,
            quality_option1_name: item.quality_option1_name,
            quality_option1_pass_yn: item.quality_option1_pass_yn,
            quality_option2_name: item.quality_option2_name,
            quality_option2_pass_yn: item.quality_option2_pass_yn,
            quality_option3_name: item.quality_option3_name,
            quality_option3_pass_yn: item.quality_option3_pass_yn,
            quality_option4_name: item.quality_option4_name,
            quality_option4_pass_yn: item.quality_option4_pass_yn,
            quality_option5_name: item.quality_option5_name,
            quality_option5_pass_yn: item.quality_option5_pass_yn,
            quality_option6_name: item.quality_option6_pass_yn,
            quality_option6_pass_yn: item.quality_option6_pass_yn,
            quality_option_name: item.quality_option_name ,
            quality_option_pass_yn: item.quality_option_pass_yn
        }));
        setOriginRows(response.data);
        setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        
    })
    .catch((error) => {
        appStore.capture();
    });
  };

  const handleRowClick = (params) => {
    handleQualityClick(params.row);
    onClose?.();
  };

  const handleDelete = () => {
    handleQualityClick({
      id: '',
      quality_name: '',
      quality_measurement_standard: '',
      quality_measurement_standard_name: '',
      quality_item_id: '',
      quality_item_name: '',
      quality_item_spec: '',
      quality_item_width: '',
      quality_item_height: '',
      quality_pass_start_number: '',
      quality_pass_start_standard: '',
      quality_pass_end_number: '',
      quality_pass_end_standard: '',
      quality_option1_name: '',
      quality_option1_pass_yn: '',
      quality_option2_name: '',
      quality_option2_pass_yn: '',
      quality_option3_name: '',
      quality_option3_pass_yn: '',
      quality_option4_name: '',
      quality_option4_pass_yn: '',
      quality_option5_name: '',
      quality_option5_pass_yn: '',
      quality_option6_name: '',
      quality_option6_pass_yn: '',
      quality_option_name: '',
      quality_option_pass_yn: ''
    });
    onClose?.();
  };

  return (
    <PCSelectModal onClose={onClose} title={title}>
        <div className="modal" style={{ maxHeight : '435px' }}>
          <table className="SelectModalTABLE">
            <tbody>
            <tr>
              <td className="SelectModalTD" colSpan={2} style={ { padding: '5px' } }>
                <div className="modal_filed_input" style={ { width: 'calc(100% - 190px)', float: 'left' } }>
                  <input type="text" placeholder="검색" value={keyword} name="keyword" onChange={(e) => setKeyword(e.target.value) } onKeyPress={onSubmitSearch} ref={searchRef} autoComplete="off" />
                </div>
                
                <div className="modal_filed_input" style={ { float: 'right' } }>
                  <Button 
                    onClick={handleView}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#3D63AE", 
                        backgroundColor: "#3D63AE",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                    }} 
                    variant="outlined">
                    조회
                  </Button>
                </div>
                <div className="modal_filed_input" style={ { float: 'right', paddingRight: '8px' } }>
                  <Button 
                    onClick={handleDelete}
                    className="btn-p btn-m"
                    sx={{  
                        m: 1, 
                        fontSize: 12, 
                        color: "white", 
                        borderColor: "#FF3636", 
                        backgroundColor: "#FF3636",
                        margin: '0px',
                        ":hover": { boxShadow: "2px 2px 2px #FF3636" , backgroundColor: "#FF3636", borderColor: "#FF3636"}
                    }} 
                    variant="outlined">
                    삭제
                  </Button>
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div style={{ padding: '5px', height: '300px' }}>
                  <DataGrid
                    rows={rows}
                    columns={columns}
                    columnVisibilityModel={columnVisibilityModel}
                    onProcessRowUpdateError={(error) => error}
                    AlternatingRowBackground="LavenderBlush"
                    rowsPerPageOptions={[20, 50, 100]}
                    onRowClick={handleRowClick}
                    initialState={{ 
                        density: 'compact'
                    }}
                    slots={{
                        noRowsOverlay: GridNoRow,
                    }}
                    sx={{
                      cursor: "pointer"
                    }}      
                    disableColumnSorting 
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td className="SelectModalTD" colSpan={2}>
                <div className="select_modal_action">
                  <div className="select_modal_button">
                    <Button 
                      onClick={()=> { onClose?.(); }}
                      className="btn-p btn-m"
                      sx={{  
                          m: 1, 
                          fontSize: 12, 
                          color: "white", 
                          borderColor: "#808080", 
                          backgroundColor: "#808080",
                          ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                      }} 
                      variant="outlined">
                      닫기
                    </Button>
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
    </PCSelectModal>
  );
}

export default QualitySelectModal;